import { Component, model, output } from '@angular/core';

@Component({
  selector: 'app-theme-side-menu-selector',
  imports: [],
  templateUrl: './theme-side-menu-selector.component.html',
  styleUrl: './theme-side-menu-selector.component.scss',
})
export class ThemeSideMenuSelectorComponent {
  mode = output<string>();
  selectedTheme = model<string>('light');
  backToMenu = output<boolean>();

  backToMenuClick() {
    this.backToMenu.emit(true);
  }

  changeTheme(theme: string) {
    this.mode.emit(theme);
    this.selectedTheme.set(theme);
    this.backToMenu.emit(true);
  }
}
